import type { DdqQueueRow } from "../types";

export type DdqDrawerProps = {
  row: DdqQueueRow | undefined;
  isOpen: boolean;
  onClose: () => void;
  onCloseAnimationComplete: () => void;
};

export enum DrawerTabType {
  Tasks = "tasks",
  Details = "details",
  Log = "log",
}
